import ProductCount from "./product-count";
import QuantityEdit from "./quantity-edit";
import { getProductGuid, getProductId } from "./product-detail";

export default class EnterCalculatorLink {
    private baseElement: HTMLElement;
    private linkElement: HTMLAnchorElement;
    private quantityEdit: QuantityEdit;
    private defaultQuantity: number;
    private openCalculator: (productCounts: ProductCount[]) => void;


    constructor(
        baseElement: HTMLElement,
        openCalculator: (productCounts: ProductCount[]) => void) {
        this.baseElement = baseElement;
        this.linkElement = this.baseElement.querySelector('#enter-calculator');
        this.linkElement = this.baseElement.querySelector('#enter-calculator');
        const quantityEditElement = this.baseElement.querySelector('[data-component-part="quantity-edit"]');
        this.defaultQuantity = Number.parseInt(this.baseElement.dataset.defaultQuantity);
        if (quantityEditElement) {
            this.quantityEdit = new QuantityEdit(this.baseElement);
        }
        this.openCalculator = openCalculator;

        this.init();
    }

    private init() {
        this.addListener();
    }

    private addListener() {
        this.linkElement.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.openCalculator([new ProductCount(getProductId(), getProductGuid(), this.quantityEdit?.getValue() ?? this.defaultQuantity)]);
        })
    }

}
